function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 254.1 47.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AOL Mail logo - Brandlogos.net") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M275,360.41c3.32,0,6.65,0,10-.06,6.38,15.41,12,31.14,18.24,46.62-4.22-.08-8.44.19-12.64-.09-1.61-1.79-1.77-4.55-2.77-6.75-5.19.15-10.4-.3-15.57.21-1,2.16-1.61,4.45-2.47,6.65-4.28,0-8.54,0-12.81,0C262.81,391.38,269,375.94,275,360.41Zm.59,29.92,8.94,0a120,120,0,0,0-4.63-14.76C278.46,380.51,277.13,385.45,275.6,390.34Z",
    transform: "translate(-256.95 -360.13)",
    style: {
      fill: "#3d3d3d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.67,360.42h10.74c-.07,15.51,0,31,0,46.53H346.71C346.65,391.44,346.73,375.93,346.67,360.42Z",
    transform: "translate(-256.95 -360.13)",
    style: {
      fill: "#3d3d3d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.83,371c6.22-1.31,13.28.12,17.79,4.8,6.82,6.85,7.08,19,.6,26.14-6.27,7.19-18.3,7.85-25.69,2s-9-17.65-3.68-25.46A17.19,17.19,0,0,1,317.83,371Zm2,9.73c-5.83,1.83-7.71,10.06-3.61,14.44,3.59,4.65,11.8,3.12,13.64-2.43C332.9,386.53,326.69,378.31,319.85,380.71Z",
    transform: "translate(-256.95 -360.13)",
    style: {
      fill: "#3d3d3d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.55,393.52c4.74-1.88,10.25,2.32,9.42,7.42-.25,5.39-7.57,8.32-11.45,4.53C495.4,402.33,496.72,395.22,501.55,393.52Z",
    transform: "translate(-256.95 -360.13)",
    style: {
      fill: "#3d3d3d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.2,360.87c2.13-1.15,5.23-.81,6.06,1.79,4.52,9.92,8.89,19.9,13.3,29.87,4.62-10.06,8.75-20.35,13.42-30.39.91-2.37,3.82-2.19,5.74-1.26,1.14,3.37.71,6.94.75,10.43q0,15.81,0,31.61c-.1,1.29,0,3.3-1.45,3.82-1.94,1.29-4.49-.56-4.21-2.78-.08-10.09.06-20.18-.06-30.28-4,8.26-7.46,16.78-11.53,25-1,2.2-4.58,2.36-5.54,0-4.07-8.25-7.54-16.78-11.56-25.05-.18,10.38.14,20.78-.15,31.17-.3,3.1-5.46,2.91-5.45-.22-.28-12.75,0-25.53-.13-38.29A16.7,16.7,0,0,1,376.2,360.87Z",
    transform: "translate(-256.95 -360.13)",
    style: {
      fill: "#258de0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.1,360.87c2.64-2.23,6.94,1.4,5.42,4.36-.85,2.76-5.09,3.27-6.47.71C460.68,364.35,461.49,362,463.1,360.87Z",
    transform: "translate(-256.95 -360.13)",
    style: {
      fill: "#258de0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.86,360.82a2.88,2.88,0,0,1,4.72,2.47c.14,11.84-.1,23.69.1,35.53-.35,3,3.21,2.75,5.1,3.58,1.49,1.49.7,4.52-1.53,4.65-2.67.3-5.86,0-7.65-2.28-1.9-2.49-1.65-5.78-1.67-8.73.13-11.21-.14-22.43.13-33.64C479.26,362,479.65,361.21,479.86,360.82Z",
    transform: "translate(-256.95 -360.13)",
    style: {
      fill: "#258de0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.92,376.14c3.94-2.9,9.25-3.25,13.95-2.59,3.73.49,7.32,3,8.37,6.71,1.72,6.29.19,12.9,1,19.3.77,2.3,3.63,5.56.45,7.28-2.37,1.25-4-1.29-5-3a15.53,15.53,0,0,1-16.9,2.24c-6.45-3.12-6.23-14.11.33-17,4.84-2.31,10.37-1.31,15.55-1.51,0-2.91.08-6.74-3-8.22-4.81-2.56-9.91.38-14.72,1.19C427.41,379.18,426.31,377.28,427.92,376.14Zm5.28,17c-3.56,1.46-3.69,7.16-.14,8.74s8.23,1.2,11.1-1.57c2-2.16,1.28-5.3,1.42-8C441.46,392.48,437.16,391.7,433.2,393.1Z",
    transform: "translate(-256.95 -360.13)",
    style: {
      fill: "#258de0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.18,374.58c1.43-1.66,4.81-.77,4.76,1.61.14,9.55.17,19.12,0,28.67-.29,3.1-5.44,2.93-5.45-.19-.28-8.5,0-17-.13-25.52C462.46,377.63,462.08,375.82,463.18,374.58Z",
    transform: "translate(-256.95 -360.13)",
    style: {
      fill: "#258de0"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAol);
export default __webpack_public_path__ + "static/media/aol.701a7caeb7ee5b709edb578d4602f9b7.svg";
export { ForwardRef as ReactComponent };